module.exports = __webpack_public_path__ + "static/blog34-ac875d20696c7bf4098b8fd413d0ee62.png";